const React = require("react")
const App = require("./src/components/App").default

exports.wrapPageElement = ({ element, props }) => {
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <App {...props}>{element}</App>
}
